import { Cached, ServiceAuthType } from '@uploadcam/common';
import { environment } from '../../environments/environment';
import { LoginWithPopupGenericAdapterInteractor } from '../auth/domain/interactors/login-with-popup-generic-adapter.interactor';
import { RefreshCredentialAdapterInteractor } from '../auth/domain/interactors/refresh-credential.interactor';
import { CommonProvider } from '../common/common.provider';
import { ExchangeZohoAuthCodeInteractor } from './domain/exchange-zoho-auth-code.interactor';
import { GetZohoAuthUrlInteractor } from './domain/get-zoho-auth-url.interactor';
import { RefreshZohoCredentialInteractor } from './domain/refresh-zoho-credential.interactor';
import { LoginWithRedirectAdapterInteractor } from '../auth/domain/interactors/login-with-redirect.interactor';
import { ExchangeAuthCodeInteractor } from '../auth/domain/interactors/exchange-auth-code.interactor';
import { LoginWithRedirectGenericAdapterInteractor } from '../auth/domain/interactors/login-with-redirect-generic-adapter.interactor';
import { LoginWithPopupAdapterInteractor } from '../auth/domain/interactors/login-with-popup-adapter.interactor';

const ZOHO_SCOPES =
  'WorkDrive.teamfolders.READ,WorkDrive.teamfolders.CREATE,WorkDrive.files.CREATE,WorkDrive.files.READ,WorkDrive.files.UPDATE,WorkDrive.files.sharing.CREATE,ZohoFiles.files.READ';

export abstract class AuthZohoProvider {
  abstract provideExchangeZohoAuthCode(): ExchangeAuthCodeInteractor;
  abstract provideLoginWithPopupZohoAdapter(): LoginWithPopupAdapterInteractor;
  abstract provideLoginWithRedirectZohoAdapter(): LoginWithRedirectAdapterInteractor;
  abstract provideRefreshZohoCredential(): RefreshCredentialAdapterInteractor;
  abstract provideRequiredScopes(): readonly string[];
}

export class AuthZohoDefaultProvider implements AuthZohoProvider {
  private getZohoAuthUrlInteractor = new GetZohoAuthUrlInteractor(
    environment.zoho.clientId,
    this.common.provideOAuthRedirectUri(ServiceAuthType.Zoho),
    ZOHO_SCOPES,
  );

  constructor(
    private readonly common: CommonProvider,
    private readonly window: Window,
  ) {}

  @Cached()
  public provideExchangeZohoAuthCode(): ExchangeAuthCodeInteractor {
    return new ExchangeZohoAuthCodeInteractor();
  }

  @Cached()
  public provideLoginWithPopupZohoAdapter(): LoginWithPopupAdapterInteractor {
    return new LoginWithPopupGenericAdapterInteractor(
      this.getZohoAuthUrlInteractor,
      this.common.provideLogger().withTag('LoginWithPopupInteractor<Zoho>'),
      environment.auth.popup.timeout,
      this.window,
      'Zoho Login',
    );
  }

  @Cached()
  public provideLoginWithRedirectZohoAdapter(): LoginWithRedirectAdapterInteractor {
    return new LoginWithRedirectGenericAdapterInteractor(this.getZohoAuthUrlInteractor);
  }

  @Cached()
  public provideRefreshZohoCredential(): RefreshCredentialAdapterInteractor {
    return new RefreshZohoCredentialInteractor(
      this.common.provideLogger().withTag('RefreshZohoCredentialInteractor'),
    );
  }

  public provideRequiredScopes(): readonly string[] {
    return [];
  }
}
